import Monitor from "@/modules/MonitorNFe/pages/Index.vue";

export default [
  {
    path: "/monitor",
    component: Monitor,
    meta: { title: "Monitor" },
  },
];
